import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProductionMaterial extends BaseModelAPI {
	static entity = 'receiptfromproductionmaterial';
	static entityName = 'receiptfromproductionmaterial';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.receiptFromProductionId = '';
			this.receiptFromProduction = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.qtyBefore = 0;
			this.qtyAfter = 0;
			this.qtyTaken = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}